import React from 'react';
import { PROCESS_STEPS } from '../data';
import { MessageSquare, FileCode2, ShieldCheck, Rocket } from 'lucide-react';

const Icons: Record<string, React.ElementType> = {
  MessageSquare,
  FileCode2,
  ShieldCheck,
  Rocket
};

export const Process: React.FC = () => {
  return (
    <section className="py-20 bg-slate-950 relative overflow-hidden border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Commission Process</h2>
          <p className="text-slate-400">How we turn your concept into a compiled jar.</p>
        </div>

        <div className="relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-slate-800 to-transparent -translate-y-1/2 z-0"></div>

          <div className="grid md:grid-cols-4 gap-8 relative z-10">
            {PROCESS_STEPS.map((step, index) => {
              const Icon = Icons[step.iconName] || MessageSquare; // Fallback

              return (
                <div key={step.id} className="group relative flex flex-col items-center text-center">
                  {/* Icon Circle */}
                  <div className="w-16 h-16 rounded-2xl bg-slate-900 border border-slate-800 flex items-center justify-center mb-6 shadow-xl group-hover:border-mc-blue/50 group-hover:scale-110 transition-all duration-300 relative">
                    <div className="text-mc-blue group-hover:text-white transition-colors">
                      <Icon className="w-6 h-6" />
                    </div>
                    {/* Number Badge */}
                    <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-slate-800 border border-slate-700 text-white flex items-center justify-center font-mono font-bold text-sm group-hover:bg-mc-blue group-hover:border-mc-blue transition-colors">
                      {index + 1}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};